import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Injectable()
export class PspService {
  openPayments () {
    const link = environment.pspV1BaseUrl;
    window.open(link, '_self');
  }
}
